/**
 * created by lei lei
 * 栏目切换来源
 */
import React, {Component} from 'react';
import {Modal, Tree, Icon, message} from 'antd'
import './SwitchBounced.css'
import {Scrollbars} from "react-custom-scrollbars";
import  folder from "./folder.png";
import file from "./file.png";
import siteSize from "./siteIcon.png"

const {TreeNode} = Tree;

export const getFirstChildKeys = (treeData, checkedKeys=[])=>{
    let keys = checkedKeys;
    treeData && treeData.map(item=>{
        if(keys.indexOf(item.key) < 0) {
            keys.push(item.key);
        }
    });
    return keys;
};

export default class SwitchBounced extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checkedKeys:[],
            checkedNodes:[],
            visible:false
        };
    }

    render() {
        const {visible, checkedKeys} = this.state;
        const {treeData} = this.props;
        let expandedKeys = JSON.parse(JSON.stringify(checkedKeys));
        let defaultExpandedKeys = getFirstChildKeys(treeData, expandedKeys);
        let siteSizeNum = 0;
        return (
            <Modal
                title="设置主栏目"
                visible={visible}
                onOk={this.onOk}
                onCancel={() => {
                    this.setState({visible: false})
                }}
            >
                <div className="treeStyle">
                    <Scrollbars style={{height: 480,width: 472}}>
                        <Tree
                            showIcon
                            checkable
                            checkedKeys={checkedKeys}
                            onCheck={this.onCheck}
                            defaultExpandedKeys={defaultExpandedKeys}
                            selectable={false}
                            className={"treeName"}
                        >
                            {this.renderTreeNodes(treeData,siteSizeNum)}
                        </Tree>
                        <style>
                            {
                                `.treeName li .ant-tree-node-content-wrapper {padding:0 15px 0 5px}`
                            }
                        </style>
                    </Scrollbars>
                </div>
            </Modal>
        );
    }
    renderTreeNodes = (data,siteSizeNum) => {
        let hideNode = this.props.hideNode || {};
        let hideNodeAttr = this.props.hideNodeAttr || "contentId";
        return data.map(item => {
            if(hideNode&&hideNode.length){
                 hideNode.forEach((Item,ids)=>{
                    if(item[hideNodeAttr] && Item[hideNodeAttr] && (item[hideNodeAttr] == Item[hideNodeAttr])) {
                        return item=''
                    }
                })
            }
            if(item){
                if (item.subtree) {
                    return (
                        <TreeNode key={item.key} title={item.title} dataRef={item} {...item}
                                  checkable={false} icon={<img src={siteSizeNum === 0 ? siteSize : folder} style={{marginTop:siteSizeNum===0 ? "-2px" : "0px"}}/>}>
                            {this.renderTreeNodes(item.subtree,siteSizeNum+1)}
                        </TreeNode>
                    );
                }
                return <TreeNode key={item.key} title={item.title} {...item} dataRef={item} disabled={item.bindVsbUser == true ? false : true}
                                 checkable={true} icon={<img src={file}/>}/>;
            }

        });
    };
    onCheck = (Keys, info) => {
        let checkedNodes=[];
        let checkedKeys=[];
        if(info.checkedNodes.length) {
            checkedNodes = info.node.props.dataRef;
            checkedKeys = [info.node.props.dataRef.key]
        } else {
            return false
        }
        this.setState({checkedNodes,checkedKeys},()=>{
            console.log('checkedNodes        ',checkedNodes)
        })
    };
    onSetCheckedKeys = (checkedKeys=[],checkedNodes={}) => {
        this.setState({checkedKeys,checkedNodes})
    };
    onOk = () => {
        let {checkedNodes} = this.state;
        if(!checkedNodes.mediaId){
            message.destroy();
            message.warn("请先选择栏目！");
            return;
        }
        if(typeof this.props.handleOk === 'function') {
            this.props.handleOk(checkedNodes)
        }
        this.hide()
    };
    show = () => {
        this.setState({visible:true})
    };
    hide=()=>{
        this.setState({visible:false})
    };
}
